<template>
  <v-container fluid style='background-color:white'>
    <v-layout row wrap fill-height justify-center>
      <v-flex xs12 sm12 md12 lg12>
        <v-card flat>
          <br />
          <v-layout justify-center >
            <v-card-title class='headlinestyle'><strong>Export รายการสั่งสินค้า</strong></v-card-title>
          </v-layout>
          <br />

        <v-layout row wrap justify-center>
          <v-flex xs12 sm11 md11 lg11>
            <v-layout row wrap justify-start align-center>
              <v-flex xs12 sm6 md3 lg3 px-5>
                <p style="color:#4C4C4C; font-size:90%;"><strong>รหัสร้านค้า</strong></p>
                <v-text-field
                v-model="username_search"
                outlined dense clearable
                v-on:input="orderfilterfunction()"
                color="pink lighten-3">
              </v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md3 lg3 px-5>
                <p style="color:#4C4C4C; font-size:90%;"><strong>ชื่อ-สกุล</strong></p>
                <v-text-field
                  v-model="name_search"
                  outlined dense clearable
                  v-on:input="orderfilterfunction()"
                  color="pink lighten-3">
                </v-text-field >
              </v-flex>
              <v-flex xs12 sm6 md3 lg3 px-5 v-for="(searchitem, i) in searchitems" :key="i">
                   <p style="color:#4C4C4C; font-size:90%;"><strong>{{searchitem.text}}</strong></p>
                    <v-combobox
                      v-model="searchitem.model"
                      :items="searchitem.items"
                      :item-text="searchitem.itemtext"
                      :item-value="searchitem.itemtext"
                      :return-object="false"
                      hide-selected
                      outlined dense
                      clearable
                      multiple
                      persistent-hint
                      small-chips
                      v-on:input="orderfilterfunction()"
                      color="pink lighten-3"
                    ></v-combobox>
                </v-flex>
                <v-flex xs12 sm6 md3 lg3 px-5>
                  <p style="color:#4C4C4C; font-size:90%;"><strong>วันที่สั่งซื้อ</strong></p>
                  <VueCtkDateTimePicker color="#F06292" :no-value-to-custom-elem="true" v-model="dateorderpicker" only-date range v-on:input="daterangefunction(dateorderpicker, 'order')">
                    <v-text-field v-model="dateorderview" outlined dense color="pink lighten-3" readonly clearable v-on:input="orderfilterfunction()"></v-text-field>
                  </VueCtkDateTimePicker>
                </v-flex>
                <v-flex xs12 sm6 md3 lg3 px-5>
                  <p style="color:#4C4C4C; font-size:90%;"><strong>วันที่จัดส่ง</strong></p>
                  <VueCtkDateTimePicker color="#F06292" :no-value-to-custom-elem="true" v-model="datedeliverypicker" only-date range v-on:input="daterangefunction(datedeliverypicker, 'delivery')">
                    <v-text-field v-model="datedeliveryview" outlined dense color="pink lighten-3" readonly clearable v-on:input="orderfilterfunction()"></v-text-field>
                  </VueCtkDateTimePicker>
                </v-flex>
                <v-flex xs12 sm6 md3 lg3 px-3>
                  <v-layout align-end justify-end>
                    <p><br /></p>
                    <div class="px-2">
                      <v-btn outlined color="indigo lighten-2" @click="exportorderdata('')">
                        <v-icon>mdi-publish mdi-flip-v</v-icon>&nbsp;Export
                      </v-btn>
                    </div>
                  </v-layout>
                </v-flex>
              </v-layout>

          <br />
          <v-data-table
            :headers="headers"
            :items="orderdata_view"
            :items-per-page="10"
            class="elevation-3"
            :loading="loading"
          >
          <template v-slot:body="{ items }">
                <tbody>
                  <tr
                    v-for="item in items"
                    :key="item._id"
                    style="cursor: pointer;"
                    align='center'
                  >
                  <td @click="openorderdetail(item._id, 1)">{{ item.order_no }}</td>
                  <td @click="openorderdetail(item._id, 1)">{{ item.username }}</td>
                  <td @click="openorderdetail(item._id, 1)">{{ item.adminref_name }}</td>
                  <td @click="openorderdetail(item._id, 1)">{{ item.name }}</td>
                  <td @click="openorderdetail(item._id, 1)">{{ item.order_date_th }}</td>
                  <td @click="openorderdetail(item._id, 1)">{{ item.tel }}</td>
                  <td @click="openorderdetail(item._id, 1)">{{ item.delivery_date_th }}</td>
                  <td @click="openorderdetail(item._id, 1)">
                    <v-chip
                      :color="getColor(item.order_status)"
                      text-color="white"
                    >{{ item.order_status_th }}
                    </v-chip>
                  </td>
                  <td @click="openorderdetail(item._id, 1)">{{ item.payment_status_th }}</td>
                  <td>
                    <v-layout justify-center>
                    <v-btn class="ma-2" outlined small fab color="error" @click="exportorderdata(item._id)">
                      <v-icon meduim>mdi-publish mdi-flip-v</v-icon>
                    </v-btn>
                    </v-layout>
                  </td>
                  </tr>
                </tbody>
          </template>
          </v-data-table>
          </v-flex>
        </v-layout>
        <br />
        <br />
        </v-card>
      </v-flex>
      <Orderdetailmodal />
    </v-layout>
  </v-container>
</template>

<script>
import Orderdetailmodal from '@/components/Orderdetailmodal'
import axios from 'axios'
import { sync } from 'vuex-pathify'
import { Parser } from 'json2csv'
import swal from 'sweetalert'
import moment from 'moment'
moment.locale('th')
export default {
  components: {
    Orderdetailmodal
  },
  data: () => ({
    headers: [
      { text: 'เลขที่เอกสาร', align: 'center', sortable: false, value: 'order_no' },
      { text: 'รหัสร้านค้า', align: 'center', sortable: false, value: 'username' },
      { text: 'เจ้าหน้าที่ผู้ดูแล', align: 'center', sortable: false, value: 'adminref_name' },
      { text: 'ชื่อ-สกุล', align: 'center', sortable: false, value: 'name' },
      { text: 'วันที่สั่ง', align: 'center', sortable: false, value: 'order_date_th' },
      { text: 'เบอร์โทร', align: 'center', sortable: false, value: 'tel' },
      { text: 'วันที่จัดส่ง', align: 'center', sortable: false, value: 'delivery_date_th' },
      { text: 'สถานะ', align: 'center', sortable: false, value: 'order_status' },
      { text: 'การชำระเงิน', align: 'center', sortable: false, value: 'payment_status' },
      { text: 'Export ข้อมูล', value: 'action', sortable: false, align: 'center' }
    ],
    orderdatas: [],
    orderdata_view: [],
    csvheader: ['วันที่เอกสาร', 'เลขที่เอกสาร', 'วันที่ใบกำกับภาษี', 'เลขที่ใบกำกับภาษี', 'รหัสลูกหนี้/เจ้าหนี้', 'รหัสซื้อขาย', 'จำนวนสินค้า', 'จำนวนแถม', 'ราคาต่อหน่วย', 'ส่วนลดต่อรายการ', 'ตน.เก็บ', 'ตน.เก็บโอนย้าย', 'ส่วนลดท้ายบิล', 'หมายเหตุท้ายบิล'],
    name_search: '',
    username_search: '',
    searchitems: [
      { text: 'เจ้าหน้าที่ผู้ดูแล', items: [], itemtext: 'adminref_name', model: [] },
      { text: 'สถานะ', items: [], itemtext: 'order_status_th', model: [] },
      { text: 'การชำระเงิน', items: [], itemtext: 'payment_status_th', model: [] }
    ],
    loading: false,
    dateorderpicker: '',
    dateorderview: '',
    datedeliverypicker: '',
    datedeliveryview: ''
  }),
  created () {
    if (this.$cookies.get('token') !== '') {
      if (this.$cookies.get('status') === 'super admin' || this.$cookies.get('status') === 'admin') {
        this.getdata()
      } else {
        this.$router.push('/')
      }
    } else {
      this.$router.push('/')
    }
  },

  methods: {
    getColor (status) {
      if (status === '00') return 'info'
      else if (status === '01') return 'success'
      else if (status === '02') return '#DD4B39'
      else if (status === '10') return '#52B9EB'
      else if (status === '11') return '#F7BA38'
      else if (status === '12') return '#388E3C'
      else if (status === '13') return '#F23B22'
      else if (status === '0') return 'info'
      else if (status === '1') return 'warning'
      else if (status === '2') return 'success'
      else if (status === '3') return '#DD4B39'
      else if (status === '4') return '#000000'
    },
    async getdata () {
      try {
        this.loading = true
        let { data } = await axios.post(`${process.env.VUE_APP_API}/order/get/all`, {
          orderstatus: ['01'],
          paymentstatus: ['0', '1', '4']
        }, {
          headers: {
            Authorization: this.$cookies.get('token')
          }
        })
        this.orderdatas = data.orderdata.filter(pd => pd.order_status === '01').map((pd, index) => {
          return {
            ...pd,
            order_date_th: moment(pd.order_date).format('ll'),
            delivery_date_th: pd.delivery_date ? moment(pd.delivery_date).format('ll') : ''
          }
        })
        this.orderdata_view = this.orderdatas
        for (const searchitem of this.searchitems) {
          searchitem.items = searchitem.items.length === 0 ? this.orderdatas : searchitem.items
        }
        this.loading = false
        this.orderfilterfunction()
      } catch (error) {
        this.loading = false
      }
    },
    openneworder () {
      this.currentorderproduct = ''
      this.$router.push('/orderdetail')
    },
    openorderdetail (id, mode) {
      this.orderdetailmodal = true
      this.currentorderid = id || ''
      this.orderdetailmode = mode === 1 ? 1 : 4
    },
    async exportorderdata (id) {
      let orderdatafilter = id ? this.orderdatas.filter(order => order._id === id) : this.orderdata_view
      if (orderdatafilter.length !== 0) {
        let header = this.csvheader
        let result = []
        orderdatafilter.forEach(orderdata => {
          let newdate = `${(orderdata.delivery_date.split('T')[0]).split('-')[2]}/${orderdata.delivery_date.split('-')[1]}/${orderdata.delivery_date.split('-')[0]}`
          orderdata.productitems.forEach(product => {
            let resultdata = {
              'วันที่เอกสาร': newdate,
              'เลขที่เอกสาร': orderdata.order_no,
              'วันที่ใบกำกับภาษี': '',
              'เลขที่ใบกำกับภาษี': '',
              'รหัสลูกหนี้/เจ้าหนี้': orderdata.username,
              'รหัสซื้อขาย': product.product_no,
              'จำนวนสินค้า': product.quantity,
              'จำนวนแถม': '',
              'ราคาต่อหน่วย': product.price,
              'ส่วนลดต่อรายการ': '',
              'ตน.เก็บ': orderdata.adminref_name,
              'ตน.เก็บโอนย้าย': '',
              'ส่วนลดท้ายบิล': '',
              'หมายเหตุท้ายบิล': ''
            }
            result.push(resultdata)
          })
        })
        const json2csvParser = new Parser({ quote: '' })
        const csv = json2csvParser.parse(result, { header })

        let swaltext = orderdatafilter.length === 1 ? `Export รายการสั่งซื้อ เลขที่: ${orderdatafilter[0].order_no}  ?` : `Export รายการสั่งซื้อทั้งหมด ${orderdatafilter.length} รายการ ?`
        await swal({
          title: swaltext,
          text: 'รายละเอียดรายการสั่งซื้อนี้สามารถ Export ได้เพียงครั้งเดียว กรุณาบันทึกรายละเอียดรายการสั่งซื้อ',
          icon: 'warning',
          buttons: ['ยกเลิก', 'Export'],
          dangerMode: true
        }).then(async (willexport) => {
          if (willexport) {
            let date = new Date()
            var downloadLink = document.createElement('a')
            var blob = new Blob(['\ufeff', csv])
            var url = URL.createObjectURL(blob)
            downloadLink.href = url
            downloadLink.download = orderdatafilter.length === 1 ? `${orderdatafilter[0].order_no}.csv` : `exportorder_${date.toISOString().split('T')[0]}.csv`
            document.body.appendChild(downloadLink)
            downloadLink.click()
            document.body.removeChild(downloadLink)
            await this.exportorderchangestatus(orderdatafilter)
          }
        })
      }
    },
    async exportorderchangestatus (orderlist) {
      try {
        await axios.post(`${process.env.VUE_APP_API}/order/edit/export`, {
          orderlist: orderlist.map(or => { return { _id: or._id } })
        }, {
          headers: {
            Authorization: this.$cookies.get('token')
          }
        })
        this.getdata()
      } catch (error) {
        await swal({
          title: `ระบบผิดพลาด`,
          text: 'กรุณาลองอีกครั้งในภายหลัง',
          icon: 'warning',
          buttons: 'ตกลง',
          dangerMode: true
        })
      }
    },
    orderfilterfunction () {
      this.orderdata_view = this.orderdatas.filter(order => {
        let condition = [
          this.name_search ? (order.name.toLowerCase()).includes((this.name_search).toLowerCase()) : true,
          this.username_search ? (order.username.toLowerCase()).includes((this.username_search).toLowerCase()) : true,
          this.searchitems[0].model.includes(order.adminref_name) || !this.searchitems[0].model.length,
          this.searchitems[1].model.includes(order.order_status_th) || !this.searchitems[1].model.length,
          this.searchitems[2].model.includes(order.payment_status_th) || !this.searchitems[2].model.length,
          this.dateorderview ? order.order_date.split('T')[0] >= this.dateorderview.split(' ~ ')[0] && order.order_date.split('T')[0] <= this.dateorderview.split(' ~ ')[1] : true,
          this.datedeliveryview ? order.delivery_date.split('T')[0] >= this.datedeliveryview.split(' ~ ')[0] && order.delivery_date.split('T')[0] <= this.datedeliveryview.split(' ~ ')[1] : true
        ]
        return condition.every(con => con)
      })
    },
    daterangefunction (datepicker, mode) {
      if (mode === 'order') {
        this.dateorderview = `${datepicker.start.split(' ')[0]} ~ ${datepicker.end ? datepicker.end.split(' ')[0] : datepicker.start.split(' ')[0]}`
      } else if (mode === 'delivery') {
        this.datedeliveryview = `${datepicker.start.split(' ')[0]} ~ ${datepicker.end ? datepicker.end.split(' ')[0] : datepicker.start.split(' ')[0]}`
      }
      this.orderfilterfunction()
    }
  },
  computed: {
    orderdetailmodal: sync('orderdetailmodal'),
    currentorderid: sync('currentorderid'),
    orderdetailmode: sync('orderdetailmode'),
    currentorderproduct: sync('currentorderproduct')
  }
}
</script>

<style scoped >
.container {
  margin: 5px;
}
.container .con {
  margin: 0px;
}
.headlinestyle {
  font-family: 'Kanit';
  font-style: normal;
  font-weight: normal;
  font-size: 30px;
  line-height: 54px;
  color: #000000;
}
.v-data-table th {
  height: 60px !important;
}

.v-data-table {
  font-family: 'Kanit';
}
td {
  max-width: 130px;
  overflow: hidden;
  text-overflow: clip;
  white-space: nowrap;
}
</style>

<style>
.date-time-picker * {
  font-family: 'Kanit' !important;
}
</style>
